export enum FileCategories {
  //TrafficAccidentSection
  DrivingLicense = 10,
  VehicleInsurance = 11,
  PoliceReport = 19,
  CompensationClaim = 23,

  //Represantation partial
  GuardianApprovalAttachment = 3,
  LawyerPowerOfAttorneyAttachment = 14,
  LawyerRepresentationAttachment = 1,
  AssociationRepresentationAttachment = 2,

  //SocialSecuritySection
  SocialSecurityApprovalDecision = 21,
  SocialSecurityProtocol = 12,

  //personalInfoSection
  IdNumberScan = 5,
  IdAttachmentScan = 7,

  //residintial address section
  LeaseContractOrPropertyTax = 6,

  //BankAccountDetailsSection
  AccountManagementCertificate = 9,

  //InjuryKindSection
  InjuryReportFiLe = 13,
  InvestigationReportFile = 16,
  ExtraInvestigationRelatedFile = 17,
  InjuryFromTheUnitOrCommandStaff = 20,
  AnotherDocumentFromServiceIndicatingInjury = 18,
  InjuryDescription = 22,

  //HospitalizationDetailsSection
  ReleaseLetter = 4,

  MedicalConfidentialityWaiver = 8,
  FormConcludingDocument = 15,

  DiseaseDescription = 24,
  WitnessDocument = 26,

  MedicalDocument = 27,
  HmoFile = 28,
  PrevHmoFile = 29,
  OtherRelatedFile = 30,
}
